// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const MORE = "V\u00edce";
export const STROLLERS_SEARCH_HOMEPAGE_BTN_TITLE = "Najdi ko\u010d\u00e1rek podle sv\u00fdch p\u0159edstav";
